import TaskRecurrenceRuleService from "../../../services/taskRecurrenceRule.service";

const generationError = (code, message) => Object.assign(new Error(message), { code });

// PUT /rules/:id returns { rule, sync }; sync deliberately omits engine
// errors. The existing generate endpoint is idempotent per occurrence and
// returns the actual run status and summary, so verify it before reporting
// a completed save. Never treat a deduplicated/inflight run as success.
export async function verifyRuleGeneration(ruleId, windowStart) {
  let response;
  try {
    response = await TaskRecurrenceRuleService.generate(ruleId,
      windowStart ? { window_start: windowStart } : {});
  } catch (error) {
    throw generationError("RECURRENCE_GENERATION_UNVERIFIED",
      "The recurring rule was saved, but future tasks could not be verified. Retry to finish; the saved rule will be reused.");
  }
  const { status, run, summary } = response?.data || {};
  if (response?.status === 202 || status === "deduped" || ["queued", "running"].includes(run?.status)) {
    throw generationError("RECURRENCE_GENERATION_BUSY",
      "The recurring rule was saved. Task generation is already running; wait for it to finish, then retry. This save has not been verified yet.");
  }
  if (["failed", "partial"].includes(run?.status) || Number(run?.error_count) > 0 || summary?.errors?.length) {
    throw generationError("RECURRENCE_GENERATION_PARTIAL",
      "The recurring rule was saved, but some future tasks could not be generated or updated. Retry to finish; existing tasks will not be duplicated.");
  }
  if (status !== "ok" || !Array.isArray(summary?.errors) || run?.status !== "succeeded") {
    throw generationError("RECURRENCE_GENERATION_UNVERIFIED",
      "The recurring rule was saved, but the generation result was not confirmed. Retry to verify the future tasks.");
  }
  const noTasks = Array.isArray(summary.generated) && Array.isArray(summary.updated) &&
    summary.generated.length === 0 && summary.updated.length === 0;
  return {
    conflicts: Math.max(Number(run?.conflict_count) || 0, summary?.conflicts?.length || 0),
    ...(noTasks ? { noTasks: true } : {}),
  };
}
